function createCustomizer() {

  const mobileHost = window.location.host;
  var mobileCustomizerURL;

  if (host.includes('dev')) {
    customizerURL = "http://cdn-staging.spectrumcustomizer.com/lululemon/frontend/js/customizer.min.js";
  } else if (host.includes('staging')) {
    customizerURL = "http://cdn-staging.spectrumcustomizer.com/lululemon/frontend/js/customizer.min.js";
  } else if (host.includes('127')) {
    customizerURL = "http://cdn-staging.spectrumcustomizer.com/lululemon/frontend/js/customizer.min.js";
  } else if (host.includes('prod')) {
    customizerURL = "https://cdn.spectrumcustomizer.com/lululemon/frontend/js/customizer.min.js";
  }
   else {
    customizerURL = "https://cdn.spectrumcustomizer.com/lululemon/frontend/js/customizer.min.js";
  }

  if (!document.getElementById('customizer-handler')) {

    if (!document.querySelector(`script[src="${mobileCustomizerURL}"]`)) {
      const script = document.createElement('script');
      script.src = mobileCustomizerURL;
      script.async = true;
      document.body.appendChild(script);
    }
  
    const div = document.createElement('div');
    div.className = 'w-100 left-0 top-0 z-[9999] fixed overflow-auto';
    div.style = "background-color: #F9F9F8; height: 100vh; padding-bottom: 90px; z-index: 9999;"
    div.id = 'customizer-handler';
    div.tabIndex = -1;
    div.innerHTML = '<div id="spectrum-customizer"></div>';
    document.body.appendChild(div);

    div.focus();
  } else {
    console.log("the customizer-handler still exists")
  }
}

// Show popup when the button is clicked
const openPopupButtonMobile = document.getElementById('openPopupButtonMobile');

if(openPopupButtonMobile) {

  openPopupButtonMobile.addEventListener('click', () => {

    var customizeButton = document.getElementsByClassName('product-form__submit');
    var sku = customizeButton[1].getAttribute('data-sku');
    var grabCustomProduct = sku;
    window.spectrumLoadProduct = grabCustomProduct;

    createCustomizer();
    lastFocused = document.activeElement;
    
  });
  
}

const checkMobileParams = new URLSearchParams(window.location.search);
const mobileRecipeID = checkMobileParams.get('recipeId');

if (mobileRecipeID) {
  createCustomizer();
}